module.exports = __webpack_public_path__ + "img/avatar5.9fabe03d.png";